import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  geeksOnlineSelect,
  getGeeksOnline,
} from "redux-api/slices/geeksOnlineSlice";
import { ONLINE_PLATFORM_URL } from "common/constants";
import monitor from "assets/image/home/hmMonitor.webp";
import monitorScreen from "assets/image/home/hmMonitorScreen.webp";
import HomeButton from "./HomeButton";
import classes from "./HomeOnline.module.scss";

// Пока поле не заполнено в админке, показываем описание из макета.
const FALLBACK_TEXT =
  "Geeks Online - инновационная образовательная платформа, предоставляющая " +
  "доступ к качественному обучению IT-профессиям, где можно получить необходимые знания " +
  "от опытных преподавателей в любое удобное для вас время.";

const HomeOnline = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { geeksOnline } = useSelector(geeksOnlineSelect);
  const [videoFailed, setVideoFailed] = useState(false);

  const videoSrc = geeksOnline?.video || null;
  const posterSrc = geeksOnline?.image || monitorScreen;

  useEffect(() => {
    dispatch(getGeeksOnline());
    return () => null;
  }, [dispatch]);

  return (
    <section className={classes.online}>
      <div className={classes.container}>
        <div className={classes.inner}>
          <div className={classes.text}>
            <h2 className={classes.title} data-aos="fade-up">
              {geeksOnline?.title || "Geeks online"}
            </h2>
            <p
              className={classes.thesis}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {geeksOnline?.text || FALLBACK_TEXT}
            </p>
            <div data-aos="fade-up" data-aos-delay="200">
              <HomeButton href={geeksOnline?.link || ONLINE_PLATFORM_URL}>
                {t("SignIn")}
              </HomeButton>
            </div>
          </div>

          {/* Монитор из макета: в экран подставляется картинка платформы. */}
          <div
            className={classes.mockup}
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <span className={classes.glow} aria-hidden />
            <img className={classes.frame} src={monitor} alt="" />
            <div className={classes.screen}>
              {videoSrc && !videoFailed ? (
                <video
                  src={videoSrc}
                  poster={geeksOnline?.video_poster || posterSrc}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  onError={() => setVideoFailed(true)}
                />
              ) : (
                <img
                  src={posterSrc}
                  alt={geeksOnline?.image_alt || "Geeks Online"}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeOnline;
